module.exports = __webpack_public_path__ + "img/PXL_20230524_111240335.e8d9edbe.jpg";